import styles from "./HeroSection.module.scss";
import useAppSelector from "../../../hooks/useAppSelector";
import defaultHeroImage from "../../../assets/images/homepage/default-hero-bg.png";
import {getImageUrlForContent} from "../../../helpers/image.helper";
import CustomButton from "../../../components/UI/CustomButton/CustomButton";
import {useNavigate} from "react-router-dom";

const HeroSection = () => {

    const navigate = useNavigate();

    const {content} = useAppSelector(state => state.siteContentSlice);

    return (
        <section className={styles.section} style={{backgroundImage: content.heroBackgroundPath ? `url(${getImageUrlForContent(content.heroBackgroundPath)})` : `url(${defaultHeroImage})`}}>
            <div className={"container"}>
                <div className={styles.content}>
                    <h1 className={styles.title}>{content.heroTitle}</h1>
                    <p className={styles.subtitle}>{content.heroDescription}</p>
                    <div className={styles.btnWrapper}>
                        {
                            content.primaryButtonText && (
                                <CustomButton
                                    text={content.primaryButtonText}
                                    typeStyle={"fill"}
                                    type={"button"}
                                    functionOnClick={() => navigate("/about-us")}
                                    borderRadius={false}
                                />
                            )
                        }
                        {
                            content.secondaryButtonText && (
                                <button className={styles.secondaryBtn} type={"button"} onClick={() => navigate("schedule")}>
                                    {content.secondaryButtonText}
                                </button>
                            )
                        }

                    </div>
                </div>
            </div>
        </section>
    )
}

export default HeroSection;